const Panel = props => {
  const { actions, children, error, title } = props || {};

  return (
    <section className="mb-10 border-t border-gray-200 pt-6">
      <div className="flex flex-col gap-4 pb-2 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-2xl font-bold">{title}</h2>
        <div className="flex flex-wrap items-center gap-4">{actions}</div>
      </div>
      {error && (
        <div role="alert" className="py-2 text-sm text-red-600">
          {error}
        </div>
      )}
      {children}
    </section>
  );
};

export default Panel;
